<template>
  <div class="m_logo">
    <header-back
      :title="`${headTit}logo`"
      @back="toBack"
    />
    <div class="m_logo_alert">
      <p>{{ $t('message["1665"]') }}。</p>
    </div>
    <div
      class="m_logo_upload"
      @click="selectSource"
    >
      <div class="preview">
        <img
          class="preview_logo"
          :src="logoInfo.logo"
        >
        <h3 class="text">
          {{ $t('message["1318"]') }}logo
        </h3>
      </div>
      <i class="cubeic-arrow" />
    </div>
    <!-- 拍照 -->
    <input
      ref="camera"
      type="file"
      class="upimg hide"
      accept="image/*"
      capture="camera"
      @change="onUploadImage"
    >
    <!--相册 -->
    <input
      ref="upload"
      type="file"
      accept="image/*"
      class="file-input hide"
      @change="onUploadImage"
    >
  </div>
</template>

<script type="text/ecmascript-6">
import headerBack from '@/components/mobile/HeaderBack'
import { mapActions, mapState } from 'vuex'
import axios from 'axios'
export default {
  components: { headerBack },
  data () {
    return {
      actions: [{
        content: this.$t('message["690"]')
      }, {
        content: this.$t('message["133"]')
      }],
      // 初始化logo数据
      logoInfo: {},
      file: {},
      fileValue: ''
    }
  },
  computed: {
    headTit () {
      return this.$t('message["1318"]')
    }
  },
  watch: {
    baseinfo (newVal) {
      document.title = 'logo - ' + this.$t('message["986"]') + newVal.projectname + '-' + newVal.comname
    }
  },
  created () {
    this.getLogo()
  },
  methods: {
    ...mapActions('config/logo', ['getLogoInitInfo', 'uploadNewLogo', 'setMobileProjectLogo']),
    ...mapState(['baseinfo']),
    toBack () {
      this.$router.push({ name: 'ProjectIndex' })
    },
    async getLogo () {
      const chain = await this.getLogoInitInfo()
      chain.onSuccess(res => {
        this.logoInfo = res
      })
        .fetch()
    },
    // 上传图片
    async uploadLogoImage () {
      const _this = this
      const chain = await this.uploadNewLogo()
      chain.params({ filename: this.fileValue })
        .onSuccess(res => {
          const { policy, signature, _upt, domain, upyunurl } = res[0]
          const { name, size, type } = _this.file
          let fileData = _this.fileToFormData({ policy, signature, file: _this.file })
          axios.post(upyunurl, fileData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          }).then(result => {
            const { url } = result.data
            let setLogoData = {
              file_name: name,
              file_size: size,
              file_type: type,
              file_url: url
            }
            _this.setLogo(setLogoData)
            _this.logoInfo.logo = domain + _upt
          }).catch(err => {
            console.log(err)
          })
        })
        .fetch()
    },
    async setLogo (params) {
      const chain = await this.setMobileProjectLogo(params)
      chain.onSuccess(res => {
        const toast = this.$createToast({
          txt: this.$t('message["1012"]'),
          type: 'correct'
        })
        toast.show()
      })
        .fetch()
    },
    fileToFormData (data) {
      const { policy, signature, file } = data
      let fileData = new FormData()
      fileData.append('policy', policy)
      fileData.append('signature', signature)
      fileData.append('file', file)
      return fileData
    },
    selectSource () {
      this.$createActionSheet({
        data: this.actions,
        onSelect: (item, index) => {
          if (index === 0) {
            this.$refs.camera.click()
          } else {
            this.$refs.upload.click()
          }
        }
      }).show()
    },
    onUploadImage (event) {
      let _this = this
      let file = event.target.files[0]
      _this.file = file
      _this.fileValue = [event.target.value]
      // 支持20M以内的文件上传
      if (file.size > 1024 * 1024 * 20) {
        _this.ToastMsg(this.$t('message["72"]'), 1)
        return
      }
      _this.uploadLogoImage()
    }
  }
}
</script>

<style scoped lang="scss">
.m_logo {
  position: relative;
  background: #fff;
  margin: 12px 0;
  overflow: hidden;
  .m_logo_alert {
    height: 60px;
    text-align: left;
    line-height: 25px;
    p {
      margin: 16px;
      color: #b3b3b3;
    }
  }
  .m_logo_upload {
    position: relative;
    height: 80px;
    box-sizing: border-box;
    border-top: 1px solid #dbdbdb;
    border-bottom: 1px solid #dbdbdb;
    cursor:pointer;
    .preview, .cubeic-arrow {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
    }
    .preview {
      left: 16px;
      .preview_logo {
        display: inline-block;
        width: 64px;
        height: 64px;
        background: #d8d8d8;
        border-radius: 4px;
        overflow: hidden;
      }
      .text {
        position: relative;
        bottom: 30px;
        display: inline-block;
        color: #333;
        font-weight: 600;
        margin-left: 16px;
      }
    }
    .cubeic-arrow {
      right: 21px;
      color: #ccc
    }
  }
}
</style>
